export enum MyEditDialogStepsEnum {
    STEP1 ,
    STEP2 ,
    STEP3 ,
    STEP4,
    STEP5 ,
    STEP6 ,
}
